module.exports = __webpack_public_path__ + "img/4广东省政府采购协会第二届会员单位.a2182673.png";